import React from 'react';
import {Link} from 'react-router-dom'

function LogoImage(props) {
    return <Link to={  `${process.env.PUBLIC_URL}/csa-home` } >
                <img src={props.logo} alt="logo" className="img-fluid" />
            </Link>;
}

export default LogoImage;